<template>
  <div class="text-center" >
    <v-menu offset-y dense open-on-hover>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" dark v-bind="attrs" v-on="on" text>
          真题搜索
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item-group>
          <v-list-item 
            v-for="(item, index) in items" 
            :key="index" 
            :to=" '/Search' + item.link "
          ><v-list-item-title>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  data: () => ({
    items: [
      { 
        title: 'AP',
        link: '/AP'
      },{ 
        title: 'IB',
        link: '/IB'
      },{ 
        title: 'A-Level (CIE)',
        link: '/AL-CIE'
      },{ 
        title: 'IGCSE (CIE)',
        link: '/IG-CIE'
      },{ 
        title: 'A-Level (Edexcel)',
        link: '/AL-Edexcel',
      },{ 
        title: 'IGCSE (Edexcel)',
        link: '/IG-Edexcel',
      },{
        title: 'A-Level (AQA)',
        link: '/AL-AQA',
      },{
        title: '国际竞赛',
        link: '/Contests'
      },{
        title: '牛剑入学考',
        link: '/Uni Admissions'
      }
    ],
  }),
}
</script>
